import clsx from 'clsx'
import PropTypes from 'prop-types'
import React, { useRef } from 'react'
import styles from 'modules/Statistics/statistics.module.scss'

const StatisticsLayout = ({
  ChartComponent,
  TableComponent,
  BreadcrumbsComponent = null,
  FilterPanel = null,
  chartVisible = true,
}) => {
  const tableContainerRef = useRef()

  return (
    <>
      <div className={'layout-tile margin-bottom-32'}>
        <div
          className={clsx({
            'margin-bottom-32': chartVisible,
          })}
        >
          {BreadcrumbsComponent}
          {FilterPanel}
        </div>

        <div
          className={clsx(styles['chart-wrapper'], {
            [styles['chart-wrapper_hidden']]: !chartVisible,
          })}
        >
          {ChartComponent}
        </div>
      </div>

      <div
        className={clsx('layout-tile')}
        ref={tableContainerRef}
      >
        {TableComponent}
      </div>
    </>
  )
}

StatisticsLayout.propTypes = {
  ChartComponent: PropTypes.element,
  TableComponent: PropTypes.element,
  BreadcrumbsComponent: PropTypes.element,
  FilterPanel: PropTypes.element,
  chartVisible: PropTypes.bool,
}

export default StatisticsLayout
